// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OsEC","icon":"styles_icon__31SW_"};